import React from 'react'
import { pathOr } from 'ramda'
import { getFilterObjectIds, makeFilterString } from '../../utils'
import { useRecJobsContext } from '../../RecommendedJobsProvider'
import { isRecommended, isClearAll } from './utils'

export const RecommendedJobsFilterView = ({ handleChange, checked }) => (
  <ul className='ais-RefinementList-list'>
    <li className='ais-RefinementList-item ais-RefinementList-item--selected'>
      <label className='ais-RefinementList-label'>
        <input className='ais-RefinementList-checkbox' type='checkbox' onChange={handleChange} checked={checked} />
        <span className='ais-RefinementList-labelText'>Recommended Only</span>
      </label>
    </li>
  </ul>
)

export class RecommendedJobsFilter extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      checked: false
    }
  }
  componentDidUpdate ({ searchState }) {
    if (searchState && isClearAll(searchState)) {
      this.setState({ checked: false })
    }
  }
  componentDidMount () {
    const { searchState } = this.props
    if (isRecommended(searchState)) {
      this.setState({ checked: true })
    }
  }

  handleChange = () => {
    const { recommendedJobsIds, onSearchStateChange, searchState } = this.props
    const prevFilters = pathOr(null, ['configure', 'filters'], searchState)
    const { checked } = this.state
    const ids = Object.keys(recommendedJobsIds)
    const filters = !checked ? getFilterObjectIds({ ids, checked, prevFilters }) : makeFilterString({ prevFilters })

    const options = {
      configure: { filters },
      recommended: !checked
    }
    onSearchStateChange(options)
    this.setState({ checked: !checked })
  }

  render () {
    return (
      <RecommendedJobsFilterView handleChange={this.handleChange} checked={this.state.checked} />
    )
  }
}

export default ({ searchState, onSearchStateChange }) => {
  const recJobs = useRecJobsContext()
  return (
    <RecommendedJobsFilter
      searchState={searchState}
      onSearchStateChange={onSearchStateChange}
      recommendedJobsIds={pathOr({}, ['data', 'recommendedJobsIds'], recJobs)} />
  )
}
